import ApplicationController from './application_controller'

export default class ToggleController extends ApplicationController {
  static targets = ['state', 'on', 'off']

  connect () {
    super.connect()
    this.toggle()
  }

  onTargetConnected (target) {
    this.stateTarget.checked ? target.classList.remove('is-hidden') : target.classList.add('is-hidden')
  }

  offTargetConnected (target) {
    this.stateTarget.checked ? target.classList.add('is-hidden') : target.classList.remove('is-hidden')
  }

  toggle () {
    this.stateTarget.checked ? this.toggleOn() : this.toggleOff()
  }

  toggleOn () {
    this.onTargets.forEach(target => target.classList.remove('is-hidden'))
    this.offTargets.forEach(target => target.classList.add('is-hidden'))
  }

  toggleOff () {
    this.offTargets.forEach(target => target.classList.remove('is-hidden'))
    this.onTargets.forEach(target => target.classList.add('is-hidden'))
  }
}
